import { render } from "./GreenBox2.vue?vue&type=template&id=68240b35"
import script from "./GreenBox2.vue?vue&type=script&lang=js"
export * from "./GreenBox2.vue?vue&type=script&lang=js"

import "./GreenBox2.vue?vue&type=style&index=0&id=68240b35&lang=css"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__